export const getAverageValue = (data: number[]): number => {
  if (data.length === 0) return 0;

  const sum = data.reduce<number>((acc, value) => acc + value, 0);

  return Math.round(sum / data.length);
};

export const convertBitToMB = (value: number) => Math.round(value / 1000000); //bits => megabits
